/* eslint-disable camelcase */
import React from "react";
import { Industries } from "components/Industries";
import { EmployeeRange } from "components/EmployeeRange";
import styles from "./CompanyDetails.module.scss";

interface CompanyDetailsProps {
    employee_range: string;
    industries: string[];
}

/**
 * Renders a list of icons and details about the company.
 */
const CompanyDetails = (props: CompanyDetailsProps) => {
    const {
        employee_range, industries
    } = props;

    return (
        <ul className={styles.companyDetails} aria-label="Company Details">
            <Industries {...{ industries }} />
            <EmployeeRange {...{ employee_range }} />
        </ul>
    );
};
CompanyDetails.displayName = "CompanyDetails";

export { CompanyDetails };
